import { useEffect, useState, useCallback } from 'react'
import { jingqueAdminApi } from '@/api/jingqueAdminApi'
import { listPoolCronStatus } from '@/api/poolAdminApi'

export interface PendingCounts {
  eduVerifyPending: number
  queueFailed: number
  queueBacklog: number
  cronStuck: number
  loading: boolean
}

export function usePendingCounts(pollMs = 60_000): PendingCounts & { refresh: () => void } {
  const [counts, setCounts] = useState<PendingCounts>({
    eduVerifyPending: 0,
    queueFailed: 0,
    queueBacklog: 0,
    cronStuck: 0,
    loading: true,
  })

  const load = useCallback(async () => {
    const [eduRes, queueRes, cronRes] = await Promise.allSettled([
      jingqueAdminApi.eduVerify.list(1, 1, 'pending'),
      jingqueAdminApi.queue.overview(),
      listPoolCronStatus(),
    ])
    setCounts({
      eduVerifyPending: eduRes.status === 'fulfilled' ? eduRes.value.total : 0,
      queueFailed:
        queueRes.status === 'fulfilled'
          ? (queueRes.value.queues || []).reduce((s, q) => s + (q.failed || 0), 0)
          : 0,
      queueBacklog:
        queueRes.status === 'fulfilled'
          ? (queueRes.value.queues || []).reduce((s, q) => s + (q.pending || 0) + (q.retry || 0), 0)
          : 0,
      cronStuck:
        cronRes.status === 'fulfilled'
          ? ((cronRes.value as any).crons || (cronRes.value as any).jobs || []).filter(
              (c: any) => !c.is_alive,
            ).length
          : 0,
      loading: false,
    })
  }, [])

  useEffect(() => {
    load()
    if (pollMs > 0) {
      const t = setInterval(load, pollMs)
      return () => clearInterval(t)
    }
  }, [load, pollMs])

  return { ...counts, refresh: load }
}
